import { Button } from "@/components/ui/button";
import moment from "moment";

export function SotDetailHandler({
  currentExport,
  data,
  dataSave,
  exportToExcel,
}) {
  if (currentExport == "sot") {
    const exportData = dataSave.service_order_tickets
      .filter((sot) => {
        if (data.date_from && data.date_to) {
          return moment(sot.reported_date).isBetween(
            data.date_from,
            data.date_to,
          );
        } else {
          return true;
        }
      })
      .map((sot) => {
        let openTime = sot.status_work.find(
          (sw) => sw.status_work_code === "OPN",
        )?.created_at;
        openTime = openTime
          ? moment(openTime).subtract(7, "hours").format("YYYY-MM-DD HH:mm:ss")
          : "-";
        let acceptedTime = sot.status_work.find(
          (sw) => sw.status_work_code === "ACC",
        )?.created_at;
        acceptedTime = acceptedTime
          ? moment(acceptedTime)
              .subtract(7, "hours")
              .format("YYYY-MM-DD HH:mm:ss")
          : "-";
        let appointmentTime = sot.appointment_date
          ? moment(sot.appointment_date)
              .subtract(7, "hours")
              .format("YYYY-MM-DD HH:mm:ss")
          : "-";
        let etaTime = sot.eta_date
          ? moment(sot.eta_date)
              .subtract(7, "hours")
              .format("YYYY-MM-DD HH:mm:ss")
          : "-";
        let departTime = sot.status_work.find(
          (sw) => sw.status_work_code === "DPT",
        )?.created_at;
        departTime = departTime
          ? moment(departTime)
              .subtract(7, "hours")
              .format("YYYY-MM-DD HH:mm:ss")
          : "-";
        let arrivedTime = sot.status_work.find(
          (sw) => sw.status_work_code === "ARV",
        )?.created_at;
        arrivedTime = arrivedTime
          ? moment(arrivedTime)
              .subtract(7, "hours")
              .format("YYYY-MM-DD HH:mm:ss")
          : "-";
        let startTime = sot.status_work.find(
          (sw) => sw.status_work_code === "STR",
        )?.created_at;
        startTime = startTime
          ? moment(startTime).subtract(7, "hours").format("YYYY-MM-DD HH:mm:ss")
          : "-";
        let stopTime = sot.status_work.find(
          (sw) => sw.status_work_code === "STP",
        )?.created_at;
        stopTime = stopTime
          ? moment(stopTime).subtract(7, "hours").format("YYYY-MM-DD HH:mm:ss")
          : "-";
        let leaveTime = sot.status_work.find(
          (sw) => sw.status_work_code === "LVE",
        )?.created_at;
        leaveTime = leaveTime
          ? moment(leaveTime).subtract(7, "hours").format("YYYY-MM-DD HH:mm:ss")
          : "-";
        let jobReportTime = sot.status_work.find(
          (sw) => sw.status_work_code === "CMP",
        )?.created_at;
        jobReportTime = jobReportTime
          ? moment(jobReportTime)
              .subtract(7, "hours")
              .format("YYYY-MM-DD HH:mm:ss")
          : "-";
        let completeTime = sot.status_work.find(
          (sw) => sw.status_work_code === "JRR",
        )?.created_at;
        completeTime = completeTime
          ? moment(completeTime)
              .subtract(7, "hours")
              .format("YYYY-MM-DD HH:mm:ss")
          : "-";

        return {
          "SOT Number": sot.so_ticket_no,
          CRM: sot.crm_ticket,
          "PRT Number": sot.part_request_ticket
            .map((prt) => prt.prt_ticket_no)
            .join(";"),
          Customer: sot.customer_name,
          WSID: sot.machine_name,
          "Machine Loc.": sot.machine_location,
          "SE Code": sot.service_engineer_se_id,
          "On Duty SE Code": sot.on_duty_service_engineer_se_id,
          "SOT Desc": sot.problem_description,
          "Service Type": sot.service_type_name,
          "Problem Type": sot.problem_type_name,
          "Problem Desc": sot.problem_description,
          "PF Type": sot.sot_form?.problem_type.name,
          "PF Note": sot.sot_form?.form.problem_notes,
          "CA Type": sot.sot_form?.corrective_type.name,
          "CA Note": sot.sot_form?.form.corrective_notes,
          "Last Status": sot.last_status_work_name,
          "Open Time": openTime,
          "Accepted Time": acceptedTime,
          "Appointment Time": appointmentTime,
          "ETA Time": etaTime,
          "Depart Time": departTime,
          "Arrived Time": arrivedTime,
          "Start Time": startTime,
          "Stop Time": stopTime,
          "Leave Time": leaveTime,
          "JR Delivery Time": jobReportTime,
          "Complete Delivery Time": completeTime,
          "list of (Suspended Code - Time - Note)": sot.status_work
            ? sot.status_work
                .filter((sw) => sw.status_work_name === "SPN")
                .map(
                  (sw) =>
                    sw.status_work_name +
                    " - " +
                    sw.created_at +
                    " - " +
                    sw.notes,
                )
                .join(";")
            : "-",
          "list of part usage (Part Name - Usage Qty)": sot.part_usages
            ? sot.part_usages
                .map((pu) => {
                  return `${pu.part_detail.name} - ${
                    pu.type == "repairable" ? 1 : pu.part_quantity
                  }`;
                })
                .join(";")
            : "-",
        };
      });
    return (
      <Button
        variant="primary"
        onClick={() =>
          exportToExcel(
            exportData,
            `sot_${moment().format("hhmm_DDMMYYYY")}.xlsx`,
          )
        }
      >
        Submit
      </Button>
    );
  }
  return null;
}
